import type { InternalAxiosRequestConfig } from 'axios';

let sessionUserId: string | null = null;
let sessionBxHash: string | null = null;

/**
 * Сессия для AJAX: hash в X-Bx-Hash (не Authorization), чтобы preflight не требовал заголовок authorization —
 * часть прокси на :8443 отдаёт OPTIONS с урезанным Access-Control-Allow-Headers без него.
 * Бэкенд: AjaxAuthHeaders::resolveHash (см. docs/auth-hardening-plan.md).
 */
export function setAxiosSessionCredentials(
    userId: number | string | null | undefined,
    hash: string | null | undefined,
): void {
    sessionUserId = userId != null && String(userId) !== '' ? String(userId) : null;
    sessionBxHash = hash != null && hash !== '' ? hash : null;
}

/** Чистая функция — удобно для unit-тестов и interceptor. */
export function sessionCredentialsToHeaders(
    userId: string | null,
    hash: string | null,
): Record<string, string> {
    const h: Record<string, string> = {};
    if (hash) {
        h['X-Bx-Hash'] = hash;
    }
    if (userId) {
        h['X-Bx-Id'] = userId;
    }
    return h;
}

export function applySessionHeadersToConfig(config: InternalAxiosRequestConfig): void {
    const extra = sessionCredentialsToHeaders(sessionUserId, sessionBxHash);
    if (Object.keys(extra).length === 0) {
        return;
    }
    const headers = config.headers;
    if (headers && typeof (headers as { set?: (k: string, v: string) => void }).set === 'function') {
        const h = headers as { set: (k: string, v: string) => void };
        if (extra['X-Bx-Hash']) {
            h.set('X-Bx-Hash', extra['X-Bx-Hash']);
        }
        if (extra['X-Bx-Id']) {
            h.set('X-Bx-Id', extra['X-Bx-Id']);
        }
        return;
    }
    config.headers = { ...config.headers, ...extra } as InternalAxiosRequestConfig['headers'];
}
